/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Scanshippingbox_Name2Inputs */

const en_resources_scanshippingbox_name2 = /** @type {(inputs: Resources_Scanshippingbox_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping box scan`)
};

const fr_resources_scanshippingbox_name2 = /** @type {(inputs: Resources_Scanshippingbox_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan boite expédition`)
};

const es_resources_scanshippingbox_name2 = /** @type {(inputs: Resources_Scanshippingbox_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escaneo de caja de expedición`)
};

const de_resources_scanshippingbox_name2 = /** @type {(inputs: Resources_Scanshippingbox_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versandkarton-Scan`)
};

const nl_resources_scanshippingbox_name2 = /** @type {(inputs: Resources_Scanshippingbox_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzenddoos-scan`)
};

/**
* | output |
* | --- |
* | "Shipping box scan" |
*
* @param {Resources_Scanshippingbox_Name2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_scanshippingbox_name2 = /** @type {((inputs?: Resources_Scanshippingbox_Name2Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Scanshippingbox_Name2Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_scanshippingbox_name2(inputs)
	if (locale === "fr") return fr_resources_scanshippingbox_name2(inputs)
	if (locale === "es") return es_resources_scanshippingbox_name2(inputs)
	if (locale === "de") return de_resources_scanshippingbox_name2(inputs)
	return nl_resources_scanshippingbox_name2(inputs)
});
export { resources_scanshippingbox_name2 as "resources.scanShippingBox.name" }